/* TIENDA DORADA · carrito
   - añadir desde la barra de tallas y desde la ficha
   - cajón lateral que se abre al añadir y al pulsar el botón del header
   - aviso flotante compartido
   - corazones guardados en el navegador
*/
(function(){
  if (window.__tdCarrito) return;
  window.__tdCarrito = true;

  /* ═════ utilidades ═════ */

  function esc(s){
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  // Shopify guarda el dinero en centavos. En pesos no se usan decimales.
  function pesos(centavos){
    var n = Math.round(Number(centavos || 0) / 100);
    try { return '$' + n.toLocaleString('es-CO'); }
    catch(e){ return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  }

  function recortar(url, ancho){
    if (!url) return '';
    return url.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_' + ancho + 'x$1$3');
  }

  /* ═════ aviso flotante ═════ */

  var aviso, avisoTitulo, avisoTexto, temporizador;

  function montarAviso(){
    if (aviso) return aviso;
    aviso = document.createElement('div');
    aviso.className = 'td-tst';
    aviso.setAttribute('role', 'status');
    aviso.setAttribute('aria-live', 'polite');
    aviso.innerHTML = '<i>✓</i><div><b></b><span></span></div>';
    document.body.appendChild(aviso);
    avisoTitulo = aviso.querySelector('b');
    avisoTexto = aviso.querySelector('span');
    return aviso;
  }

  function mostrar(titulo, texto, esError){
    montarAviso();
    avisoTitulo.textContent = titulo;
    avisoTexto.textContent = texto || '';
    aviso.classList.toggle('td-error', !!esError);
    aviso.querySelector('i').textContent = esError ? '!' : '✓';
    aviso.classList.add('td-on');
    clearTimeout(temporizador);
    temporizador = setTimeout(function(){ aviso.classList.remove('td-on'); }, 2600);
  }
  window.tdAviso = mostrar;

  /* ═════ cajón lateral ═════ */

  var cajon, cuerpo, contador, urlCarrito = '/cart', urlTienda = '/collections/all';
  var ultimoFoco = null;

  function localizarCajon(){
    if (cajon && document.body.contains(cajon)) return cajon;
    cajon = document.querySelector('[data-td-cajon]');
    if (!cajon) return null;

    // lo sacamos al body: el header es sticky y crea un contexto de apilado propio
    if (cajon.parentNode !== document.body) document.body.appendChild(cajon);

    cuerpo     = cajon.querySelector('[data-td-cj-cuerpo]');
    contador   = cajon.querySelector('[data-td-cj-n]');
    urlCarrito = cajon.getAttribute('data-url-carrito') || urlCarrito;
    urlTienda  = cajon.getAttribute('data-url-tienda') || urlTienda;

    cajon.querySelectorAll('[data-td-cerrar-cajon]').forEach(function(b){
      b.addEventListener('click', cerrarCajon);
    });
    return cajon;
  }

  function abrirCajon(){
    if (!localizarCajon()) return;
    ultimoFoco = document.activeElement;
    cajon.classList.add('td-on');
    cajon.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var cerrar = cajon.querySelector('.td-cj-h button');
    if (cerrar) setTimeout(function(){ cerrar.focus(); }, 60);
  }

  function cerrarCajon(){
    if (!cajon) return;
    cajon.classList.remove('td-on');
    cajon.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }

  window.tdAbrirCarrito = function(){ abrirCajon(); pedirCarrito(); };
  window.tdCerrarCarrito = cerrarCajon;

  function pintarCajon(carrito){
    if (!localizarCajon()) return;

    if (contador) contador.textContent = carrito.item_count;

    if (!carrito.items || carrito.items.length === 0){
      cuerpo.innerHTML =
        '<div class="td-cj-vac">' +
          '<i><svg viewBox="0 0 24 24"><path d="M6 7h12l-1.2 12.2a1.6 1.6 0 0 1-1.6 1.4H8.8a1.6 1.6 0 0 1-1.6-1.4z"/><path d="M9 9.5V6.6a3 3 0 0 1 6 0v2.9"/></svg></i>' +
          '<b>Tu carrito está vacío</b>' +
          '<p>Todavía no has añadido nada. Echa un vistazo a la temporada.</p>' +
          '<a class="td-btn td-btn-o td-btn-sm" href="' + esc(urlTienda) + '">Ver la tienda <i>→</i></a>' +
        '</div>';
      return;
    }

    var filas = carrito.items.map(function(it, i){
      var variante = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      var img = it.image ? recortar(it.image, 220) : '';
      return '' +
        '<li class="td-cj-it" data-td-linea="' + (i + 1) + '">' +
          '<a class="td-cj-im" href="' + esc(it.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') +
          '</a>' +
          '<div class="td-cj-in">' +
            '<a class="td-cj-tt" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
            (variante ? '<span class="td-cj-vr">' + esc(variante) + '</span>' : '') +
            '<div class="td-cj-ac">' +
              '<div class="td-stp">' +
                '<button type="button" data-td-cant="' + (it.quantity - 1) + '" aria-label="Quitar uno">−</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" data-td-cant="' + (it.quantity + 1) + '" aria-label="Añadir uno">+</button>' +
              '</div>' +
              '<span class="td-cj-pz">' + pesos(it.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="td-cj-qt" data-td-cant="0">Quitar</button>' +
          '</div>' +
        '</li>';
    }).join('');

    cuerpo.innerHTML =
      '<ul class="td-cj-l">' + filas + '</ul>' +
      '<div class="td-cj-ft">' +
        '<div class="td-cj-sb"><span>Subtotal</span><b>' + pesos(carrito.total_price) + '</b></div>' +
        '<small>Los impuestos y el envío se calculan al pagar.</small>' +
        '<a class="td-btn td-btn-o" href="/checkout">Ir a pagar <i>→</i></a>' +
        '<a class="td-cj-seg" href="' + esc(urlCarrito) + '">Ver el carrito completo</a>' +
      '</div>';
  }

  function pedirCarrito(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(carrito){
        document.dispatchEvent(new CustomEvent('td:carrito', { detail: { total: carrito.item_count } }));
        pintarCajon(carrito);
        return carrito;
      });
  }
  window.tdRefrescarCarrito = pedirCarrito;

  /* cambiar cantidad dentro del cajón */
  document.addEventListener('click', function(e){
    var boton = e.target.closest('[data-td-cant]');
    if (!boton || !boton.closest('[data-td-cajon]')) return;

    e.preventDefault();
    var fila = boton.closest('[data-td-linea]');
    if (!fila) return;

    var cantidad = Number(boton.getAttribute('data-td-cant'));
    if (cantidad < 0) return;

    fila.classList.add('td-cargando');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(fila.getAttribute('data-td-linea')), quantity: cantidad })
    })
    .then(function(r){ return r.json(); })
    .then(function(carrito){
      document.dispatchEvent(new CustomEvent('td:carrito', { detail: { total: carrito.item_count } }));
      pintarCajon(carrito);
    })
    .catch(function(){
      fila.classList.remove('td-cargando');
      mostrar('No se pudo actualizar', 'Inténtalo de nuevo', true);
    });
  });

  /* abrir el cajón desde el botón del header */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-td-abrir-carrito]');
    if (!b) return;
    e.preventDefault();
    window.tdAbrirCarrito();
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && cajon && cajon.classList.contains('td-on')) cerrarCajon();
  });

  /* ═════ añadir al carrito ═════ */

  document.addEventListener('click', function(e){
    var boton = e.target.closest('[data-td-anadir]');
    if (!boton) return;

    e.preventDefault();
    e.stopPropagation();

    var id = boton.getAttribute('data-td-variante');
    if (!id) return;

    boton.classList.add('td-cargando');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
    .then(function(r){
      if (!r.ok) return r.json().then(function(d){ throw new Error(d.description || d.message || 'No se pudo añadir'); });
      return r.json();
    })
    .then(function(){ return pedirCarrito(); })
    .then(function(){ abrirCajon(); })
    .catch(function(err){
      mostrar('No se pudo añadir', err.message || 'Inténtalo de nuevo', true);
    })
    .finally(function(){
      boton.classList.remove('td-cargando');
    });
  });

  /* ═════ corazón · guardado local ═════ */

  var CLAVE = 'td_guardados';
  function leer(){
    try { return JSON.parse(localStorage.getItem(CLAVE) || '[]'); } catch(e){ return []; }
  }
  function pintarFavoritos(){
    var lista = leer();
    document.querySelectorAll('[data-td-fav]').forEach(function(b){
      b.classList.toggle('td-on', lista.indexOf(b.getAttribute('data-td-fav')) !== -1);
    });
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-td-fav]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = b.getAttribute('data-td-fav');
    var lista = leer();
    var i = lista.indexOf(handle);
    if (i === -1) lista.push(handle); else lista.splice(i, 1);
    try { localStorage.setItem(CLAVE, JSON.stringify(lista)); } catch(err){}
    pintarFavoritos();
  });

  function arrancar(){
    localizarCajon();
    pintarFavoritos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();
